import { useSearchParams } from "react-router-dom";
import Store from "logic/local-storage/Store";
const ASSET_ID_SEARCH_PARAM_KEY = "assetIdSearchParam";
function useAssetIdSearchParam() {
  const [searchParams] = useSearchParams();
  return {
    assetIdSearchParam: searchParams.get("assetId") || Store.get(ASSET_ID_SEARCH_PARAM_KEY),
    saveAssetIdSearchParam: (assetId) => Store.set(ASSET_ID_SEARCH_PARAM_KEY, assetId)
  };
}
export default useAssetIdSearchParam;
